<template>
  <div class="list-wrapper">
    <video-player
      class="video-player vjs-custom-skin"
      :options="playerOptions"
      @play="onplay($event)"
      @pause="onpause"
      @ended="onended"
    ></video-player>
    <div class="video_detail">
      <p class="video_name">{{name}}</p>
      <p class="video_time" v-if="total_length && total_length != 0">时长：{{total_length | formatSeconds}}</p>
    </div>
  </div>
</template>
<script>
import record from "../../utils/record.js";
import videojs from "../../../static/js/video.js";
import formatSeconds from "../../utils/formatSecond.js";
import timeFormats from "../../utils/timeFormat_record.js";
window.videojs = videojs;
require("videojs-flash");
videojs.options.flash.swf = "../../../static/video-js.swf";

export default {
  data() {
    return {
      name: this.$route.query.name,
      total_length: this.$route.query.time,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        sources: [
          {
            type: "application/x-mpegURL",
            src: this.$route.query.playurl, // 你的m3u8地址（必填）
          },
        ],
        controlBar: {
          timeDivider: true,
        },
        autoplay: true,
      },
      recordTimer: null,
    };
  },
  mounted() {
    document.title = '优课'
  },
  filters: {
    formatSeconds: function (value) {
      return formatSeconds(value);
    },
  },
  methods: {
    // 收集学习记录
    uprecord(current_position, total_length) {
      let inTime = new Date().getTime();
      let recordParams = {
        sso_id: this.$route.query.sso_id,
        appid: 'youke',
        erp_id: this.$route.query.order_id,
        cid: this.$route.query.cid,
        package_id: this.$route.query.package_id,
        course_id: 1,
        unit_id: this.$route.query.id,
        action_time: timeFormats(new Date() / 1000),
        product: 8,
        is_online: 1,
        module_type: 2,
        current_position: current_position,
        total_length: total_length,
        course_type: 1,
        version: 0,
        other: {
          traceID: inTime,
        },
      };
      record(recordParams);
    },
    onplay(player) {
      this.uprecord(Math.floor(player.currentTime()), player.duration());
      let that = this;
      this.recordTimer = setInterval(function () {
        that.uprecord(Math.floor(player.currentTime()), player.duration());
      }, 60000);
    },
    onpause() {
      clearInterval(this.recordTimer);
      this.recordTimer = null;
    },
    onended() {
      clearInterval(this.recordTimer);
      this.recordTimer = null;
    }
  }
};
</script>

<style lang="less">
.video-js .vjs-current-time {
  display: block;
}
.video-js .vjs-remaining-time{
  display: none;
}
.video-player {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 422px;
  z-index: 100;
}
.video-js {
  width: 100%;
  height: 422px;
  .vjs-big-play-button {
    width: 100px;
    height: 90px;
    border-radius: 50%;
    top: 160px;
    left: 317px;
  }
}
.video_detail {
  background: #ffffff;
  padding: 30px 30px;
  padding-top: 452px;
  .video_name {
    font-size: 34px;
    font-weight: bold;
  }
  .video_time {
    margin-top: 20px;
    color: #999999;
  }
}
.other_videos {
  margin-top: 10px;
  background: #ffffff;
  .other_title {
    padding: 30px 30px 0;
    font-size: 34px;
    font-weight: bold;
  }
  .video_region {
    height: calc(100vh - 670px);
    overflow-y: scroll;
  }
  .single_video {
    display: flex;
    align-items: center;
    padding: 30px 30px;
    border-bottom: 1px solid #e6e6e6;
    .video_pic {
      width: 44px;
      height: 42px;
    }
    .video_content {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-left: 20px;
      .other_videos_name {
        font-size: 28px;
        font-weight: bold;
      }
      .video_params {
        color: #999999;
        margin-top: 20px;
        .live_sign {
          color: #94070a;
          float: right;
          img {
            width: 24px;
            height: 22px;
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/video/video.vue